'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProductData = exports.fetchJSON = exports.getDefaultRequestConfig = exports.resizeImage = exports.formatMoney = exports.range = exports.createElement = exports.doesStringContainAny = exports.getElements = exports.getElement = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _currency = require('@shopify/theme-currency/currency');

var shopifyCurrency = _interopRequireWildcard(_currency);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var getElement = exports.getElement = function getElement(selector) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === undefined ? document : _ref$context;

  return context.querySelector(selector);
};

/**
 * Returns a list of elements that are a descendant of node that
 * matches selectors.
 *
 * @param {String} selector - A DOMString containing one or more selectors to match. This string must
 *   be a valid CSS selector string
 * @param {Object} [config] - You can pass a context to scope the element selection
 * @param {HTMLElement|Document} [context=Document] - The scope we will try and find the element in
 * @param {Boolean} [asArray=true] - Return the elements as an Array instead of an NodeList?
 *
 * @returns {Array|NodeList} The found elements or null
 */
/**
 * Returns the first element that is a descendant of node that
 * matches selectors.
 *
 * @param {String} selector - A DOMString containing one or more selectors to match. This string must
 *   be a valid CSS selector string
 * @param {Object} [config] - You can pass a context to scope the element selection
 * @param {HTMLElement|Document} [context=Document] - The scope we will try and find the element in
 *
 * @returns {HTMLElement} The found element or null
 */
var getElements = exports.getElements = function getElements(selector) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? document : _ref2$context,
      _ref2$asArray = _ref2.asArray,
      asArray = _ref2$asArray === undefined ? true : _ref2$asArray;

  var items = context.querySelectorAll(selector);

  return asArray ? (0, _from2.default)(items) : items;
};

/**
 * Checks if the passed string contains any items in an array
 *
 * @param {String} str - The string we will be searching
 * @param {Array} [items] - A list of the items we will be checking for presence in the str
 *
 * @returns {Boolean}
 */
var doesStringContainAny = exports.doesStringContainAny = function doesStringContainAny(str) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return items.some(function (i) {
    return str.includes(i);
  });
};

/**
 * Creates an HTMLElement
 *
 * @param {String} tag - What type of element we want this to be
 * @param {Object} [options] - A key / value pair of properties and values we want to set on the newly
 *   created element
 *
 * @returns {HTMLElement}
 */
var createElement = exports.createElement = function createElement(tag) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var el = document.createElement(tag);

  (0, _entries2.default)(options).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    el.setAttribute(key, value);
  });

  return el;
};

/**
 * Creates an array starting from zero with the length of the passed amount
 *
 * @param {Number} amount - How long do we want this array to be?
 *
 * @returns {Array}
 */
var range = exports.range = function range(amount) {
  return [].concat((0, _toConsumableArray3.default)(Array(amount).keys()));
};

/**
 * A wrapper around Shopify's formatMoney so we can pass the initial theme format
 *
 * @param {Number} cents - The form we will be traversing to find the properties
 * @param {String} [format] - format - shop money_format setting
 *
 * @return {String} value - formatted value
 */
var formatMoney = exports.formatMoney = function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.theme.moneyFormat;
  return shopifyCurrency.formatMoney(cents, format);
};

/**
 * A Javascript equivalent of Shopify's | img_url filter
 *
 * @param {Object} The properties we will use to create the URL
 * @param {String} src - The Shopify CDN URL of the image
 * @param {String} size - What size we want the image to be
 * @param {null|String} [crop=null] - By default the images aren't cropped but we can choose to crop them
 * @param {null|Number} [scale=null] - Images are 1x by default, you can choose to pass a different scale
 *
 * @returns {String}
 */
var resizeImage = exports.resizeImage = function resizeImage() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      src = _ref5.src,
      size = _ref5.size,
      _ref5$crop = _ref5.crop,
      crop = _ref5$crop === undefined ? null : _ref5$crop,
      _ref5$scale = _ref5.scale,
      scale = _ref5$scale === undefined ? null : _ref5$scale;

  if (size == null) {
    return src;
  }

  if (size === 'master') {
    return src.replace(/http(s)?:/, '');
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

  if (match != null) {
    var prefix = src.split(match[0]);
    var suffix = match[0];
    var scaleString = scale ? '@' + scale + 'x' : '';
    var cropString = crop ? '_crop_' + crop : '';

    return (prefix[0] + '_' + size + cropString + scaleString + suffix).replace(/http(s)?:/, '');
  } else {
    return null;
  }
};

/**
 * This is the default config we will use when using fetch()
 *
 * @returns {Object}
 */
var getDefaultRequestConfig = exports.getDefaultRequestConfig = function getDefaultRequestConfig() {
  return JSON.parse((0, _stringify2.default)({
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    }
  }));
};

/**
 * Default fetch boilerplate
 * @param {String} url - The URL we are looking to fetch
 * @param {Object} [config] - .fetch config to override the default
 *
 * @returns {Promise}
 */
var fetchJSON = exports.fetchJSON = function fetchJSON(url) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetch(url, (0, _assign2.default)({}, getDefaultRequestConfig(), config)).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
};

/**
 * This will fetch product data from Shopify's AJAX API by handle
 *
 * @param {String} handle - The products handle
 *
 * @returns {Promise}
 */
var fetchProductData = exports.fetchProductData = function fetchProductData(handle) {
  try {
    return fetchJSON('/products/' + handle + '.js');
  } catch (e) {
    console.error(e);
  }
};